import { render, staticRenderFns } from "./OnRegistration.vue?vue&type=template&id=4b33027f"
import script from "./OnRegistration.vue?vue&type=script&lang=js"
export * from "./OnRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports